export default __webpack_public_path__ + "static/media/Sans_titre-58.24d57641.png";